<template>
  <div>
    <div class="container">
      <span class="title is-3">{{ empresa.nombrec }}</span>
      <small class="title is-5"
        >{{ empresa.nit | textnumber() }}{{ empresa.nit | dverif() }}</small
      >
      <small class="subtitle is-7">{{ empresa.nombre }}</small>
      <hr />
      <div class="field is-grouped">
        <p class="control has-icons-left has-icons-right">
          <input
            class="input is-normal is-focused"
            type="text"
            v-model="search"
            placeholder="Buscar Tercero"
          />
          <span class="icon is-medium is-left">
            <i class="material-icons">search</i>
          </span>
        </p>
        <div class="control">
          <div class="tags has-addons">
            <span class="tag is-medium has-background-grey-lighter"
              >Total Terceros</span
            >
            <span class="tag is-info is-medium">{{ pagination.count }}</span>
          </div>
        </div>
        <p class="control">
          <button class="button" @click="downloadTerceros">
            <span class="material-icons">arrow_circle_down</span>&nbsp;
            <span>Descargar</span>
          </button>
        </p>
        <p class="control" v-if="showEdit">
          <button class="button" @click="cancelEdit">
            <span>Lista</span>
          </button>
        </p>
        <p class="control">
          <button v-if="!showEdit" class="button" @click="addnit">
            <span class="icon is-small">
              <span class="material-icons">add_circle_outline</span>
            </span>
            <span>Crear</span>
          </button>
        </p>
        <p class="control">
          <button v-if="!showEdit" class="button" @click="camposearch">
            <span class="icon is-small">
              <span class="material-icons">add_circle_outline</span>
            </span>
            <span>Campo search</span>
          </button>
        </p>
        <p class="control">
          <button v-if="!showEdit" class="button" @click="deleteunused">
            <span class="icon is-small">
              <span class="material-icons">delete_forever</span>
            </span>
            <span>Eliminar no usados</span>
          </button>
        </p>
        <!-- <p class="control">
          <button v-if="!showEdit" class="button" @click="downloadPDF">
            <span class="icon is-small">
              <span class="material-icons">archive</span>
            </span>
            <span>PDF</span>
          </button>
        </p> -->
      </div>
    </div>
    <hr />
    <div v-if="showList" class="container">
      <table class="table is-hoverable is-fullwidth">
        <thead>
          <tr>
            <th>#</th>
            <th>Rut</th>
            <th>Nombre</th>
            <th>Tipo</th>
            <th>Ciudad</th>
            <th>Clase</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(nit, index) in nits" :key="index">
            <td>{{ index + pagination.inicial * 20 + 1 }}</td>
            <td>
              <small
                ><strong class="fontMono"
                  >{{ nit.codigo | textnumber()
                  }}{{ nit.codigo | dverif() }}</strong
                ></small
              >
            </td>
            <td>
              <small>{{ nit.nombre }}</small>
            </td>
            <td>
              <small>{{ nit.tipo }}</small>
            </td>
            <td>
              <small
                class="fontMono"
                v-show="nit.tipo == 'Empresa Extranjera'"
                >{{ nit.pais }}</small
              >
              <small
                class="fontMono"
                v-show="nit.tipo != 'Empresa Extranjera'"
                >{{ nit.ciudad }}</small
              >
            </td>
            <td>{{ nit.clase }}</td>
            <td>
              <span class="icon has-text-info hand" @click="selectNit(nit)">
                <i class="material-icons">edit</i>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <nav class="pagination" role="navigation" aria-label="pagination">
        <a class="pagination-previous" @click="previous">Anterior</a>
        <a class="pagination-previous">{{ pagination.inicial + 1 }}</a>
        <a class="pagination-next" @click="next">Siguiente</a>
        <ul class="pagination-list">
          <li>
            <a
              class="pagination-link"
              :class="pagination.inicial === 0 ? 'is-current' : ''"
              aria-label="Page 1"
              aria-current="page"
              @click="ir(0)"
              >1</a
            >
          </li>
          <li v-show="pagination.total > 1">
            <a
              class="pagination-link"
              :class="pagination.inicial === 1 ? 'is-current' : ''"
              aria-label="Goto page 2"
              @click="ir(1)"
              >2</a
            >
          </li>
          <li v-show="pagination.total > 2">
            <a
              class="pagination-link"
              :class="pagination.inicial === 2 ? 'is-current' : ''"
              aria-label="Goto page 3"
              @click="ir(2)"
              >3</a
            >
          </li>
          <li>
            <span class="pagination-ellipsis">&hellip;</span>
          </li>
          <li v-show="pagination.total > 5">
            <a
              class="pagination-link"
              :class="
                pagination.inicial === pagination.mitad - 1 ? 'is-current' : ''
              "
              @click="ir(pagination.mitad - 1)"
              >{{ pagination.mitad }}</a
            >
          </li>
          <li>
            <span class="pagination-ellipsis">&hellip;</span>
          </li>
          <li v-show="pagination.total > 4">
            <a
              class="pagination-link"
              :class="
                pagination.inicial === pagination.total - 1 ? 'is-current' : ''
              "
              aria-label="Goto page 47"
              @click="ir(pagination.total - 1)"
              >{{ pagination.total }}</a
            >
          </li>
        </ul>
      </nav>
    </div>
    <div v-if="showEdit" class="container">
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">Nit</label>
            <div class="field has-addons">
              <div class="control is-expanded">
                <input
                  v-model="datatoeditnit.codigo"
                  id="codigo"
                  class="input is-fullwidth"
                  type="text"
                  placeholder="Nit"
                  @keydown="keyNitFunc($event, 'tipo', 'tipo')"
                />
              </div>
              <p class="control">
                <a class="button is-static">{{
                  datatoeditnit.codigo | dverif()
                }}</a>
              </p>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">Tipo</label>
            <div class="control is-expanded">
              <div class="select is-fullwidth">
                <select
                  v-model="datatoeditnit.tipo"
                  id="tipo"
                  @keydown="keyNitFunc($event, 'nombre', 'nombre1')"
                >
                  <option value="Persona Jurídica">Persona Jurídica</option>
                  <option value="Persona Natural">Persona Natural</option>
                  <option value="Empresa Extranjera">Empresa Extranjera</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="columns" v-show="datatoeditnit.tipo === 'Persona Natural'">
        <div class="column">
          <div class="field">
            <label class="label">Primer Nombre</label>
            <div class="control">
              <input
                v-model="datatoeditnit.nombre1"
                id="nombre1"
                class="input"
                type="text"
                placeholder="Primer Nombre"
                @keydown="keyNitFunc($event, 'nombre', 'nombre2')"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">Segundo Nombre</label>
            <div class="control">
              <input
                v-model="datatoeditnit.nombre2"
                id="nombre2"
                class="input"
                type="text"
                placeholder="Segundo Nombre"
                @keydown="keyNitFunc($event, 'nombre', 'apellido1')"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="columns" v-show="datatoeditnit.tipo === 'Persona Natural'">
        <div class="column">
          <div class="field">
            <label class="label">Primer Apellido</label>
            <div class="control">
              <input
                v-model="datatoeditnit.apellido1"
                id="apellido1"
                class="input"
                type="text"
                placeholder="Primer Apellido"
                @keydown="keyNitFunc($event, 'nombre', 'apellido2')"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">Segundo Apellido</label>
            <div class="control">
              <input
                v-model="datatoeditnit.apellido2"
                id="apellido2"
                class="input"
                type="text"
                placeholder="Segundo Apellido"
                @keydown="keyNitFunc($event, 'nombre', 'nombre')"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">Razon Social</label>
            <div class="control">
              <input
                v-model="datatoeditnit.nombre"
                id="nombre"
                class="input"
                type="text"
                placeholder="Razon Social"
                @keydown="keyNitFunc($event, 'direccion', 'direccion')"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">Dirección</label>
            <div class="control">
              <input
                v-model="datatoeditnit.direccion"
                id="direccion"
                class="input"
                type="text"
                placeholder="Dirección"
                @keydown="keyNitFunc($event, 'telefono', 'telefono')"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">Teléfono</label>
            <div class="control">
              <input
                v-model="datatoeditnit.telefono"
                id="telefono"
                class="input"
                type="text"
                placeholder="Teléfono"
                @keydown="keyNitFunc($event, 'correo', 'correo')"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">Correo</label>
            <div class="control">
              <input
                v-model="datatoeditnit.correo"
                id="correo"
                class="input"
                type="email"
                placeholder="@mail"
                @keydown="keyNitFunc($event, 'ciudad', 'ciudad')"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">Ciudad</label>
            <div class="control">
              <div class="select is-fullwidth">
                <select
                  v-model="datatoeditnit.ciudad"
                  id="ciudad"
                  @keydown="keyNitFunc($event, 'pais', 'pais')"
                >
                  <option
                    v-for="(op, ind) in ciudades"
                    :value="`${op.codigo} - ${op.nombre}`"
                    :key="ind"
                  >
                    {{ op.codigo }} - {{ op.nombre }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">País</label>
            <div class="control">
              <div class="select is-fullwidth">
                <select
                  v-model="datatoeditnit.pais"
                  id="pais"
                  @keydown="keyNitFunc($event, 'guardar', 'guardar')"
                >
                  <option
                    v-for="(op, ind) in paises"
                    :selected="
                      datatoeditnit.pais == op.codigo + ' - ' + op.nombre
                    "
                    :value="`${op.codigo} - ${op.nombre}`"
                    :key="ind"
                  >
                    {{ op.codigo }} - {{ op.nombre }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">Responsabilidades fiscales</label>
            <div class="control is-expanded">
              <div class="select is-fullwidth">
                <select v-model="datatoeditnit.regimen">
                  <option value="O-13">Gran Contribuyente</option>
                  <option value="O-15">Autorretenedor</option>
                  <option value="O-23">Agente de retención IVA</option>
                  <option value="O-47">Régimen simple de tributación</option>
                  <option value="R‐99‐PN">No aplica - Otros</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">Código postal</label>
            <div class="field">
              <div class="control is-expanded">
                <input
                  v-model="datatoeditnit.postalcode"
                  class="input is-fullwidth"
                  type="text"
                  placeholder="Código postal"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">Clasificación</label>
            <div class="control is-expanded">
              <div class="select is-fullwidth">
                <select v-model="datatoeditnit.clase">
                  <option value="general">General</option>
                  <option value="cliente">Cliente</option>
                  <option value="proveedor">Proveedor</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="columns" v-show="error">
        <div class="column">
          <div class="notification is-danger">
            <button class="delete" @click="closeerror"></button>
            {{ error }}
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="buttons" style="margin-top: 16px">
            <button class="button is-info" @click="saveEditData">
              Guardar
            </button>
            <button class="button" @click="cancelEdit">Cancelar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import apiServices from "@/services/yungol-services";
import functions from "@/helpers/functions";
const filterItems = (query, data) => {
  return data.filter((el) => {
    const texto = el.nombre + el.codigo + el.ciudad + el.pais + el.tipo;
    if (texto.toLowerCase().indexOf(query.toLowerCase()) > -1) {
      return el;
    }
  });
};
export default {
  data() {
    return {
      nits: [],
      ciudades: [],
      paises: [],
      error: null,
      search: "",
      showEdit: false,
      showList: true,
      datatoeditnit: {},
      showFormNit: {
        nit: "",
        index: "",
      },
      pagination: {
        count: 0,
        inicial: 0,
        total: 0,
        mitad: 0,
      },
    };
  },
  mounted() {
    this.traeParametros(this);
  },
  computed: {
    ...mapState(["idtoken", "empresa", "closenitModal"]),
    filteredItems: function () {
      return filterItems(this.search, this.nits);
    },
  },
  methods: {
    async deleteunused() {
      try {
        const _this = this;
        this.$store.dispatch("notify", {
          message:
            "Esto tomará varios minutos. Consulte los cambios dentro de 15 minutos.",
          type: "is-info",
          position: "top-center",
          duration: 5000,
        });
        setTimeout(function () {
          _this.$store.commit("loading1", false);
        }, 600);
        await apiServices.get("/deleteunusednits");
      } catch (err) {
        console.log(err);
      }
    },
    closeerror() {
      this.error = null;
    },
    async camposearch() {
      try {
        let result = await apiServices.post("/agregatesearchnit");
        console.log("camposearch------>", result);
      } catch (err) {
        console.log(err);
      }
    },
    async downloadTerceros() {
      try {
        console.log("empresaaa", this.empresa);
        let result = await apiServices.post(
          `/download3os`,
          { empresa: this.empresa.nit },
          { responseType: "blob" }
        );
        console.log(result);
        const url = window.URL.createObjectURL(new Blob([result.data]));
        const link = document.createElement("a");
        link.href = url;
        let ahora = new Date();
        ahora = ahora.toISOString();
        link.setAttribute(`download`, `Terceros${ahora}.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
      } catch (err) {
        console.log(err);
      }
    },
    async downloadPDF() {
      try {
        let result = await apiServices.post(`/downloadpdf`);
        console.log("PDF ------>", result.data);
        const url = result.data;
        const link = document.createElement("a");
        link.href = url;
        let ahora = new Date();
        ahora = ahora.toISOString();
        link.setAttribute(`download`, `Terceros${ahora}.pdf`); // or any other extension
        document.body.appendChild(link);
        link.click();
      } catch (err) {
        console.log(err);
      }
    },
    async traeParametros(_this) {
      let result;
      try {
        result = await apiServices.get(`/parametros`);
        _this.ciudades = [];
        _this.paises = [];
        result.data.forEach(function (key, val) {
          if (key.codigo === 1) {
            const myObj = {
              nombre: key.parametro.nombre,
              codigo: key.parametro.codigo,
            };
            _this.ciudades.push(myObj);
          } else {
            const myObj1 = {
              nombre: key.parametro.nombre,
              codigo: key.parametro.codigo,
            };
            _this.paises.push(myObj1);
          }
        });
        _this.ciudades.push({
          nombre: "Ciudad",
          codigo: "00",
        });
        _this.paises.push({
          nombre: "País",
          codigo: "00",
        });
        _this.ciudades = functions.order(_this.ciudades, "codigo");
        _this.paises = functions.order(_this.paises, "codigo");
      } catch (err) {
        console.log("ocurrio un problema cargando las cuentas", err);
      }
    },
    addnit() {
      this.$store.commit("launchModalnit");
    },
    selectNit(nit) {
      this.showEditNit();
      if (nit.tipo === "Persona Natural") {
        this.datatoeditnit._id = nit._id;
        this.datatoeditnit.ciudad = nit.ciudad;
        this.datatoeditnit.codigo = nit.codigo;
        this.datatoeditnit.nombre = nit.nombre;
        this.datatoeditnit.nombre1 = nit.nombre1;
        this.datatoeditnit.nombre2 = nit.nombre2;
        this.datatoeditnit.pais = nit.pais;
        this.datatoeditnit.tipo = nit.tipo;
        this.datatoeditnit.apellido1 = nit.apellido1;
        this.datatoeditnit.apellido2 = nit.apellido2;
        this.datatoeditnit.direccion = nit.direccion;
        this.datatoeditnit.correo = nit.correo;
        this.datatoeditnit.telefono = nit.telefono;
        this.datatoeditnit.regimen = nit.regimen;
        this.datatoeditnit.postalcode = nit.postalcode;
        this.datatoeditnit.clase = nit.clase;
        this.datatoeditnit.namesearch = nit.nombre
          .concat(" ", nit.codigo)
          .toLowerCase();
      } else {
        this.datatoeditnit._id = nit._id;
        this.datatoeditnit.ciudad = nit.ciudad;
        this.datatoeditnit.codigo = nit.codigo;
        this.datatoeditnit.nombre = nit.nombre;
        this.datatoeditnit.pais = nit.pais;
        this.datatoeditnit.tipo = nit.tipo;
        this.datatoeditnit.direccion = nit.direccion;
        this.datatoeditnit.correo = nit.correo;
        this.datatoeditnit.telefono = nit.telefono;
        this.datatoeditnit.regimen = nit.regimen;
        this.datatoeditnit.postalcode = nit.postalcode;
        this.datatoeditnit.clase = nit.clase;
        this.datatoeditnit.namesearch = nit.nombre
          .concat(" ", nit.codigo)
          .toLowerCase();
      }
    },
    showEditNit() {
      if (this.showEdit) {
        this.showEdit = false;
        this.showList = true;
      } else {
        this.showEdit = true;
        this.showList = false;
      }
    },
    saveEditData() {
      if (!this.datatoeditnit.codigo) {
        this.error = "Ingrese un código en el campo de Nit";
        return false;
      }
      if (this.datatoeditnit.tipo === "") {
        this.error = "Debe seleccionar un tipo";
        return false;
      }
      if (!this.datatoeditnit.nombre) {
        this.error = "Ingrese la Razon Social";
        return false;
      }
      this.error = null;
      this.saveEditNit(this, this.datatoeditnit);
    },
    async saveEditNit(_this, editData) {
      try {
        await apiServices.put(`/editnit`, editData);
        this.$store.dispatch("notify", {
          message: "Perfecto!. Tercero editado con éxito.",
        });
        this.find();
        this.showEditNit();
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema guardando el nit.",
          type: "is-danger",
          position: "top-center",
        });
        console.log("ocurrio un problema editando el nit", err);
      }
    },
    previous() {
      if (this.pagination.inicial > 0) {
        this.pagination.inicial--;
        this.find();
      }
    },
    next() {
      if (this.pagination.inicial + 1 < this.pagination.total) {
        this.pagination.inicial++;
        this.find();
      }
    },
    ir(n) {
      this.pagination.inicial = n;
      this.find();
    },
    async find() {
      try {
        const _this = this;
        const f = {
          search: _this.search,
          inicial: _this.pagination.inicial * 20,
        };
        let result;
        result = await apiServices.post(`/searchnit`, f);
        _this.nits = result.data.data;
        _this.pagination.count = result.data.count;
        _this.pagination.total = Math.ceil(_this.pagination.count / 20);
        _this.pagination.mitad = Math.round(
          (_this.pagination.total - 3) / 2 + 3
        );
        if (_this.nits.length === 0) {
          _this.pagination.inicial = 0;
        }
      } catch (error) {
        console.log(error);
      }
    },
    cancelEdit() {
      this.showEditNit();
    },
    keyNitFunc(event, a, d) {
      // a es el id de la celda la cual se dirige y d es la direccion si es persona natural
      if (event.keyCode === 13) {
        event.preventDefault();
        if (this.datanit.tipo === "Persona Natural") {
          document.getElementById(d).focus();
        } else {
          document.getElementById(a).focus();
        }
      }
    },
  },
  watch: {
    search(nv, ov) {
      this.find();
    },
  },
  created() {
    if (this.idtoken) {
      this.find();
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/configurations/terceros/Terceros.vue